import { isPlatformBrowser } from "@angular/common";
import { inject, Pipe, PipeTransform, PLATFORM_ID } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
    name: "safeHtml",
    standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
    readonly platformId = inject(PLATFORM_ID);

    constructor(private sanitizer: DomSanitizer) {}

    private decodeHtml(html: string): string {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    transform(
        value: string,
        type: "html" | "url" | "resourceUrl" | "script" | "style" = "html",
    ): any {
        if (!isPlatformBrowser(this.platformId)) return "";
        if (!value) return "";

        switch (type) {
            case "html":
                return this.sanitizer.bypassSecurityTrustHtml(
                    this.decodeHtml(value),
                );
            case "url":
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case "resourceUrl":
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            case "script":
                return this.sanitizer.bypassSecurityTrustScript(value);
            case "style":
                return this.sanitizer.bypassSecurityTrustStyle(value);
            default:
                return this.sanitizer.bypassSecurityTrustHtml(value);
        }
    }
}
